export default __webpack_public_path__ + "static/media/diary-screenshot-05.45a27cf3.png";